/**
 * The words of three HR payroll features of 2026-10-10: a carried advance recovery held to Art.
 * 92(1)'s share as a legal reading (human-resources-q7krz3cb), and the retroactive wage difference a
 * backdated raise owes for days already paid, proposed by the engine and decided by the reviewer
 * (human-resources-q7ks2fz0). Kept beside the catalogue, as the other HR rounds' words are, and
 * spread into it.
 */
export const HR_PAYROLL_FEATURES_EN = {
    // human-resources-q7krz3cb: the carried part of an advance recovery, and the reading that holds it.
    "value.legal_reading.payroll.advance_carried_cap": "An advance's recovery carried to later runs",
};
export const HR_PAYROLL_FEATURES_AR = {
    "value.legal_reading.payroll.advance_carried_cap": "استرداد السلفة المرحّل إلى مسيّرات لاحقة",
};
//# sourceMappingURL=i18n-hr-payroll-features.js.map